import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { BasketPersonalShoppingAdvice } from '../components/basket/basket-personal-shopping-advice/BasketPersonalShoppingAdvice';
import { useAemConfig } from '@as-react/common-components';
import LocalStorageUtil from '../util/LocalStorageUtil';
import { makeGetBasketStatusState } from '../redux/basket/selectors/BasketSelector';
import { Box } from '@as/cotopaxi';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import { BasketStatus } from '@as-react/common-types';
import { PERSONAL_SHOPPING_ADVICE_STORAGE_KEY } from '../constants/StorageKeysConstants';
const BasketPersonalShoppingAdviceContainer = ({ getProducts, isHorizontal, basketStatus, }) => {
    const { defaultRequestParams, servicesEndpoint, root, isShopLanding } = useAemConfig();
    const [personalShoppingAdvice, setPersonalShoppingAdvice] = useState();
    const isPersonalShoppingAdviceEnabled = () => !!personalShoppingAdvice && personalShoppingAdvice === 'true';
    useEffect(() => {
        if (isShopLanding) {
            const value = LocalStorageUtil.getJsonItem(PERSONAL_SHOPPING_ADVICE_STORAGE_KEY);
            if (value) {
                setPersonalShoppingAdvice(value);
            }
        }
    }, []);
    useEffect(() => {
        if (isShopLanding && isPersonalShoppingAdviceEnabled() && isHorizontal) {
            getProducts(); // Todo: remove after basket redesign is used
        }
    }, [personalShoppingAdvice]);
    return isShopLanding && isPersonalShoppingAdviceEnabled() && basketStatus === BasketStatus.READY ? (_jsx(Box, { mobile: !isHorizontal && { spacing: { marginTop: 3 } }, children: _jsx(BasketPersonalShoppingAdvice, { root: root, defaultRequestParams: defaultRequestParams, servicesEndpoint: servicesEndpoint, isHorizontal: isHorizontal }) })) : null;
};
const makeMapStateToProps = () => {
    const getBasketStatusState = makeGetBasketStatusState();
    const mapStateToProps = state => ({
        basketStatus: getBasketStatusState(state),
    });
    return mapStateToProps;
};
const mapDispatchToProps = {
    getProducts: basketActions.createGetAction,
};
export default connect(makeMapStateToProps, mapDispatchToProps)(BasketPersonalShoppingAdviceContainer);
